import { request } from 'graphql-request';
import { API_URL } from 'appenv';
import { GraphQLVideoCallRoomCreatePayload, GraphQLVideoCallRoomCreateInput } from './graphql-models';

export enum IMService {
  RongCloud = 'RONGCLOUD',
  Twilio = 'TWILIO',
}

const videoRoomCreateMutation = `
  mutation videoCallRoomCreate($inviterId: String!, $inviteeId: String!, $conversationId: String, $imService: IMService) {
    videoCallRoomCreate(input: {
      inviterId: $inviterId,
      inviteeId: $inviteeId,
      conversationId: $conversationId,
      imService: $imService,
    }) {
      success
      videoCallRoom {
        token
        status
      }
      errors {
        path
        message
        type
        details {
          key
          value
        }
      }
    }
  }
`;

const createVideoCallRoom = (inviterId: string, inviteeId: string, conversationId: string, imService: string): Promise<GraphQLVideoCallRoomCreatePayload> => request(
  API_URL,
  videoRoomCreateMutation,
  {
    inviterId,
    inviteeId,
    conversationId,
    imService,
  } as GraphQLVideoCallRoomCreateInput,
).then(({ videoCallRoomCreate }) => videoCallRoomCreate);

export default createVideoCallRoom;
